import { mergeMap, withLatestFrom } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IGetSelectorStateType } from '@cbridge-utils/reselect';
import { OrderLifetimeAction } from '@cbridge-packages/order-lifetime';
import { detailsSidebarResourceIdSelector, DetailsSidebarAction } from '@cbridge-packages/details-sidebar';

type IState = IGetSelectorStateType<typeof detailsSidebarResourceIdSelector>;

export const closeOrderLifetimeBeforeRemoveEpic: IEpic<IState> = (action$, state$) => action$.pipe(
  isTypeOfAndGetPayload(OrderLifetimeAction.remove.started),
  withLatestFrom(state$),
  mergeMap(([payload, state]) => {
    const { orderLifetimeId } = payload;
    const openedDetailsId = detailsSidebarResourceIdSelector(state);

    if (openedDetailsId !== undefined && String(openedDetailsId) === String(orderLifetimeId)) {
      return [
        DetailsSidebarAction.close({ skipUnsavedChangesConfirmation: true }),
      ];
    }

    return [];
  }),
);
